<template>
  <FormContainer without-divider>
    <template #title>
      {{ estCIPI ? 'Dates prévisionnelles de formation et mission' : 'Dates prévisionnelles de formation' }}
    </template>
    <template #content>
      <div class="form__bloc">
        <WrapperInputDate
          id="field_1a"
          label="Date de début prévisionnelle de la formation"
          v-model="dateDebutFormationModel"
          :required="meta.formation?.dateDebutPrevisionnelle?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dateDebutPrevisionnelle?.$messageErreurDirty"
          :readonly
          :hint="HINT_DATE"
          deletable
          class="col-10 col-md-18 col-sm-36"
        />
        <WrapperInputDate
          id="field_1b"
          :label="
            estCIPI
              ? 'Date de fin prévisionnelle du parcours (formation + mission)'
              : 'Date de fin prévisionnelle de la formation'
          "
          v-model="dateFinFormationModel"
          :required="meta.formation?.dateFinPrevisionnelle?.$status === PropertyStatus.Required"
          :alertLabel="meta.formation?.dateFinPrevisionnelle?.$messageErreurDirty"
          :readonly
          :hint="HINT_DATE"
          deletable
          class="col-10 col-md-18 col-sm-36"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { DEMANDE_STORE, FormContainer, HINT_DATE } from '@/features/interface/demande/shared'
  import { storeToRefs } from 'pinia'
  import { inject, computed } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_CXPI'>()
  const { setupFieldWithKey } = store
  const { meta, readonly } = storeToRefs(store)

  const estCIPI = computed(() => {
    return store.model?.sousDispositif === 'CIPI'
  })

  const dateDebutFormationModel = setupFieldWithKey<string>('formation.dateDebutPrevisionnelle', true)
  const dateFinFormationModel = setupFieldWithKey<string>('formation.dateFinPrevisionnelle', true)
</script>

<style scoped lang="less"></style>
